import {request} from '../../lib/api.js'
// Owner-only administration. These endpoints never imply generic workspace,
// creation, revision, email, financial or other tool permissions.
export const artworkReadAccessApi={
 subjects:(after=null,opts={})=>request('/api/artwork-created/read-grants/subjects',{...opts,query:after?{after}:{}}),
 list:(userId,opts={})=>request('/api/artwork-created/read-grants',{...opts,query:{userId}}),
 company:(userId,companyId,opts={})=>request(`/api/artwork-created/read-grants/company/${encodeURIComponent(companyId)}`,{...opts,query:{userId}}),
 save:(body,opts={})=>request('/api/artwork-created/read-grants',{...opts,method:'POST',body}),
}
